<template>
  <BaseButton ghost small @click="open">
    <span class="truncate"> Remove </span>
  </BaseButton>
</template>

<script>
import { accProductProductsClient } from '@/api/clients';

export default {
  props: {
    accProductId: {
      type: String,
      required: true,
    },
    product: {
      type: Object,
      required: true,
    },
  },
  data() {
    return {
      showForm: false,
    };
  },
  methods: {
    async open() {
      this.$modal.show({
        component: () => import('Components/AccProductProducts/ProductRemoveModal.vue'),
        props: {
          action: async (productId) => {
            try {
              await accProductProductsClient.destroy(this.accProductId, productId);

              return Promise.resolve();
            } catch (error) {
              return Promise.reject(error);
            }
          },
          product: this.product,
        },
        on: {
          'product-removed': (product) => {
            this.$emit('product-removed', product);
          },
        },
        hideEvent: 'hide',
      });
    },
  },
};
</script>
